export default "__VITE_ASSET__COQ41zpO__"